import React from 'react'
import { Typography, Placeholder, Brandy } from '@leshen/ui'

const RichTextDisclaimer = ({ identifier, brandy, content }) => {
  if (!brandy && !content) {
    return (
      <Placeholder type="error">
        <Typography variant="small">Error:</Typography>
        <Typography>
          No disclaimer found for identifier: ${identifier}
        </Typography>
        <br />
        <Typography>
          Be sure to double check the disclaimer ID in Contentful, as that is
          most often the cause for this error
        </Typography>
      </Placeholder>
    )
  }

  return (
    <Brandy
      variant="legal"
      symbol={brandy?.symbol}
      text={brandy?.text}
      content={content}
    />
  )
}

export default RichTextDisclaimer
